import { useDroppable } from '@dnd-kit/core'

export const SPACER_ID = 'grid-spacer'

export default function DropSpacer() {
  const { setNodeRef, isOver } = useDroppable({ id: SPACER_ID })

  return (
    <div
      ref={setNodeRef}
      className={`gap-spacer grid-row-spacer${isOver ? ' is-over' : ''}`}
    />
  )
}
